<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'mass-transfers',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/issuance-creation/index', label: 'Mass payment' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/massTransfers/MassTransfers.Entry.vue